'use strict'

class BarChart{
	constructor(containerId, data){
		this.containerId = containerId;
		this.data = data;
		this.barWidth = 500;
		//this.create = this.showBar.bind(this);
		this.showBar = this.showBar.bind(this);
		this.onExpand = this.onExpand.bind(this);
		this.onCollapse = this.onCollapse.bind(this);
		this.leftOffset = 5;
	}

	updateBar(data){
		this.data = data;
	}
	
	showBar(){
		document.getElementById("min").innerHTML = Math.round(this.data.carbonMin);
		document.getElementById("max").innerHTML = Math.round(this.data.carbonMax);
		document.getElementById("exp-tooltip").innerHTML = "Average: " + Math.round(this.data.carbonAvg);
		document.getElementById("green-tooltip").innerHTML ="Your GreenFLY: "+Math.round(this.data.carbonMin);
		//var barWidth = 500; //hard coded for now, as the width in css is not accessable for some reason
		const dotPos = -(this.barWidth - (this.data.carbonAvg-this.data.carbonMin) / (this.data.carbonMax - this.data.carbonMin) * this.barWidth)-this.leftOffset;
		const greenDotPos = -(this.barWidth - (this.data.carbonMin-this.data.carbonMin) / (this.data.carbonMax - this.data.carbonMin) * this.barWidth)-this.leftOffset;
		$("#dot").css("left", dotPos);
		$("#green-dot").css("left", greenDotPos);
	}

	onExpand(carbonNow){
		console.log("on expand bar chart");
		//var barWidth = 500;
		let newPos = -(this.barWidth - (carbonNow-this.data.carbonMin) / (this.data.carbonMax - this.data.carbonMin) * this.barWidth)-this.leftOffset;
		if (newPos == -this.leftOffset)
			newPos = -45;	//offset when current is MAX
		else
			newPos -= 22;
		$("#dot").css("left", newPos);
		if (carbonNow == this.data.carbonMin){
			document.getElementById("exp-tooltip").className = 'green_tooltip';
			document.getElementById("exp-tooltip").innerHTML = "You are Looking at Your GreenFLY!";//+Math.round(carbonNow);
		}
		else{
			document.getElementById("exp-tooltip").className = 'tooltip';
			document.getElementById("exp-tooltip").innerHTML = "Current Flight: "+Math.round(carbonNow);
		}
	}

	onCollapse(){
		const dotPos = -(this.barWidth - (this.data.carbonAvg-this.data.carbonMin) / (this.data.carbonMax - this.data.carbonMin) * this.barWidth)-this.leftOffset;
		$("#dot").css("left", dotPos);
		document.getElementById("exp-tooltip").className = 'tooltip';
		document.getElementById("exp-tooltip").innerHTML = "Average: " + Math.round(this.data.carbonAvg);
	}
}

export default BarChart



// WEBPACK FOOTER //
// ./components/BarChart.js